<template>
  <div>
    <div class="title">咨询与建议</div>
    <div class="form">
      <div class="left">
        <div class="formItem">
          <div class="formLabel" style="position:relative;top:-20px;">内容：</div>
          <textarea cols="30" rows="10" class="formTextarea" v-model="contentVal"></textarea>
          <div class="inputNum">(最多200字)：已输入 <span class="num">{{ contentVal.length }} </span>字</div>
        </div>
        <div class="formItem">
          <div class="formLabel">反馈类型：</div>
          <a-select style="width:280px;"></a-select>
        </div>
        <div class="formItem">
          <div class="formLabel">姓名：</div>
          <input type="text" class="formInput">
        </div>
        <div class="formItem">
          <div class="formLabel">电话：</div>
          <input type="text" class="formInput">
        </div>
        <div class="formItem">
          <div class="formLabel">邮件：</div>
          <input type="text" class="formInput">
        </div>
        <div class="formItem">
          <button class="sumBtn">提交</button>
        </div>
      </div>
      <div class="right">
        <div class="noticeBox">
          <ul class="noticeUl">
            <li class="noticeLi">请留下真实的姓名和电话，以便及时联系回复</li>
            <li class="noticeLi">尊重网上道德，遵守中华人民共和国的各项有关法律法规</li>
            <li class="noticeLi">承担一切因您的行为而直接或间接导致的民事或刑事法律责任</li>
            <li class="noticeLi">本站管理人员有权保留或删除其管辖留言中的任意内容</li>
            <li class="noticeLi">在此留言即表明您已经阅读并接受上述条款</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="title">咨询与答复</div>
    <div class="listItem">
      <div class="questionBox">
        <div class="contentStatus">张栋 于 2020-12-02 15:10:28 留言</div>
        <div class="content">老师，你好，请问校外用户次台设备怎么没法在网页上预约？？</div>
      </div>
      <div class="answerBox">
        <div class="contentStatus">于 2020-12-03 10:50:38 留言</div>
        <div class="content">这台设备一直处于故障维修状态。您可预约其它电镜。</div>
      </div>
    </div>
    <div class="listItem">
      <div class="questionBox">
        <div class="contentStatus">张栋 于 2020-12-02 15:10:28 留言</div>
        <div class="content">老师，你好，请问校外用户次台设备怎么没法在网页上预约？？</div>
      </div>
      <div class="answerBox">
        <div class="contentStatus">于 2020-12-03 10:50:38 留言</div>
        <div class="content">这台设备一直处于故障维修状态。您可预约其它电镜。</div>
      </div>
    </div>
    <div class="listItem">
      <div class="questionBox">
        <div class="contentStatus">张栋 于 2020-12-02 15:10:28 留言</div>
        <div class="content">老师，你好，请问校外用户次台设备怎么没法在网页上预约？？</div>
      </div>
      <div class="answerBox">
        <div class="contentStatus">于 2020-12-03 10:50:38 留言</div>
        <div class="content">这台设备一直处于故障维修状态。您可预约其它电镜。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DayiConsult',
  data() {
    return {
      contentVal: '',
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  height: 25px;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  position: relative;
  margin-left: 12px;
  margin-bottom: 15px;
  &::before {
    width: 4px;
    height: 18px;
    background: #519bcd;
    content: '';
    position: absolute;
    left: -12px;
    top: 3px;
  }
}
.form {
  width: 100%;
  display: flex;
  .left {
    width: 50%;
    .formItem {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 10px;
      .formLabel {
        width: 76px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .formTextarea {
        width: 280px;
        height: 60px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(24,144,255,.2);
          border-color: #40a9ff;
        }
      }
      .inputNum {
        margin-top: 8px;
        width: 356px;
        text-align: right;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        .num {
          color: #E5AA16;
        }
      }
      .formInput {
        width: 280px;
        height: 30px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(24,144,255,.2);
          border-color: #40a9ff;
        }
      }
      /deep/ .ant-select-selection--single {
        height: 30px;
      }
      /deep/ .ant-select-selection {
        border-radius: 2px;
      }
      .sumBtn {
        width: 64px;
        height: 30px;
        background: #519bcd;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        margin-left: 164px;
        border: 0;
        cursor: pointer;
        letter-spacing: .2rem;
        margin-top: 2px;
        &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(24,144,255,.2);
          border-color: #40a9ff;
        }
        &:hover {
          background: #519bcddb;
        }
      }
    }
  }
  // 资讯与建议，右侧提醒
  .right {
    width: 50%;
    .noticeBox {
      width: 420px;
      height: 142px;
      background: #FAFAFA;
      border: 1px solid #EEEEEE;
      .noticeUl {
        padding-left: 28px;
        list-style: none;
        margin-bottom: 0;
        margin-top: 12px;
        .noticeLi {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          position: relative;
          &::before {
            position: absolute;
            top: 10px;
            left: -14px;
            content: '';
            width: 4px;
            height: 4px;
            background: #519bcd;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
// 问答box
.listItem {
  width: 100%;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  .questionBox {
    width: 100%;
    height: 72px;
    background: url('../../assets/images/bianzuC.png');
    background-size: 100% 100%;
    .contentStatus {
      padding: 12px 0 12px 60px;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 20px;
    }
    .content {
      margin-left: 70px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
    }
  }
  .answerBox {
    width: 100%;
    height: 72px;
    background: #FAFAFA;
    border: 1px solid #EEEEEE;
    .contentStatus {
      margin: 12px 0 12px 80px;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 20px;
    }
    .content {
      margin-left: 90px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
    }
  }
}
</style>